const akForm = {
  title: 'Alaska 529 Account Forms',
  link: 'https://www.alaska529plan.com/account-holder.html#account-holder-forms',
};

const mdForm = {
  title: 'Maryland College Investment Plan Account Forms',
  link: 'https://maryland529.com/Account-Holders/Maryland-College-Investment-Plan/MCIP-Forms',
};

const natForm = {
  title: 'T. Rowe Price College Savings Plan Account Forms',
  link: 'https://www.troweprice.com/personal-investing/troweprice-529/forms-and-documents.html',
};

const trpForm = {
  title: 'T. Rowe Price Account Forms',
  link: 'https://individual.troweprice.com/public/Retail/hUtility/Forms-&-Literature',
};

const getTransactionLandingForms = ({
  hasAK529,
  hasAPP,
  hasBrokerage,
  hasMD529,
  hasMutualFund,
  hasNAT529,
}) => {
  const forms = [];
  if (hasMutualFund || hasBrokerage || hasAPP) {
    forms.push(trpForm);
  }
  if (hasAK529) {
    forms.push(akForm);
  }
  if (hasMD529) {
    forms.push(mdForm);
  }
  if (hasNAT529) {
    forms.push(natForm);
  }
  return forms;
};

export default getTransactionLandingForms;
